import React, { PropTypes, Component } from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import { Divider } from 'material-ui';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import HelperLink from '../helper-link';
import RateTable from '../../../generic-components/rate-tables/rate-table-template-container';

const propTypes = {
  extras: PropTypes.array,
  supplierEditable: PropTypes.bool,
  contractState: PropTypes.string,
  hideHeader: PropTypes.bool,
  showBorder: PropTypes.bool,
  openAddEditContractDialog: PropTypes.func,
  classes: PropTypes.object,
};
class Extras extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }
  render() {
    const {
      extras,
      supplierEditable,
      contractState,
      hideHeader,
      showBorder,
      openAddEditContractDialog,
      classes = {},
    } = this.props;

    const addAnExtra = () =>
      openAddEditContractDialog({
        type: 'manageExtrasOffers',
        data: { title: 'Add Extra' },
        offersOrExtras: { type: 'extras', createNew: true },
      });
    return (
      <div className={classes.main}>
        {!hideHeader && <Divider style={{ marginTop: '24px', marginBottom: '24px' }} />}
        {!hideHeader && (
          <HelperLink
            labelText="EXTRAS"
            value="extras"
            showSync={Boolean(extras && extras.length)}
            actions={[
              {
                label: 'Manage Extras (Beta)',
                onTouchTap: () =>
                  openAddEditContractDialog({
                    type: 'manageExtrasOffers',
                    title: 'Manage Extras',
                    offersOrExtras: { type: 'extras' },
                  }),
              },
            ]}
          />
        )}
        {!(extras && extras.length) ? (
          <AddItemCard text="Add extras" onClick={addAnExtra} editable={supplierEditable} />
        ) : (
          extras.map((extra, index) => (
            <MouseOverEditDiv
              key={index}
              editable={supplierEditable}
              actionButtons={
                <EditButton
                  onEdit={() =>
                    openAddEditContractDialog({
                      type: 'manageExtrasOffers',
                      title: 'Manage Extras',
                      offersOrExtras: {
                        type: 'extras',
                        selectedId: extra._id,
                      },
                    })
                  }
                  onDelete={() =>
                    openAddEditContractDialog({
                      type: 'manageExtrasOffers',
                      title: 'Manage Extras',
                      offersOrExtras: {
                        type: 'extras',
                        selectedId: extra._id,
                        toDelete: true,
                      },
                    })
                  }
                  deleteButton
                />
              }
            >
              <div
                style={
                  showBorder
                    ? { border: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '8px' }
                    : { marginBottom: '16px' }
                }
                className={classes[`${index}-extra`]}
              >
                <div style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.1)' }}>
                  <b className={classes[`${index}-extraType`]}>{extra.extraType}</b>
                  {extra.extraCode ? (
                    <div style={{ color: '#878787' }} className={classes[`${index}-extraCode`]}>
                      Code: <b>{extra.extraCode}</b>
                    </div>
                  ) : undefined}
                </div>
                <RateTable
                  productType="Non-Accommodation"
                  rateSet={{ ...extra }}
                  contractState={contractState}
                  editable={false}
                  forOffer
                  classes={classes[`${index}-ratesClasses`]}
                />
                <div className={classes[`${index}-description`]} style={{ whiteSpace: 'pre-wrap' }}>
                  {extra.description}
                </div>
              </div>
            </MouseOverEditDiv>
          ))
        )}

        {extras && extras.length && supplierEditable ? (
          <AddItemCard
            text="Add another extra"
            onClick={addAnExtra}
            editable={supplierEditable}
            hide={!supplierEditable}
          />
        ) : undefined}
      </div>
    );
  }
}

Extras.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { reducerName, extras }) => {
  if (extras) return { extras };
  return {
    extras: contracting[reducerName].getIn(['rightSideContent', 'extras'])
      ? contracting[reducerName].getIn(['rightSideContent', 'extras']).toJS()
      : [],
    supplierEditable: contracting[reducerName].getIn(['leftNav', 'supplierEditable']),
    contractState: contracting[reducerName].getIn(['leftNav', 'contractState']),
  };
};
export default connect(mapStateToProps)(Extras);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/left-column/left-extras.jsx